import {
  ROSTER_LOADING,
  ROSTER_LOAD,
  ROSTER_ERROR,
  ROSTER_AUDIT_LOAD,
  ROSTER_AUDIT_CLEAR,
} from '../actions/agentRoster';

const defaultState = {
  agentType:    'doctor',     // 'doctor' | 'tele_caller'
  loading:      false,
  error:        null,
  agents:       [],
  // Per-agent audit (loaded lazily when "View history" is opened)
  auditAgentId: null,
  audit:        [],
};

export default function agentRoster(state = defaultState, action) {
  switch (action.type) {
    case ROSTER_LOADING:
      return { ...state, loading: true, error: null };

    case ROSTER_LOAD: {
      const p = action.payload || {};
      return {
        ...state,
        loading:   false,
        error:     null,
        agentType: p.agentType || state.agentType,
        agents:    p.agents || [],
      };
    }

    case ROSTER_AUDIT_LOAD:
      return {
        ...state,
        auditAgentId: action.payload.agentId,
        audit:        action.payload.audit,
      };

    case ROSTER_AUDIT_CLEAR:
      return { ...state, auditAgentId: null, audit: [] };

    case ROSTER_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
